//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';

import Carousel from 'nuka-carousel';

//import Components

import GreenHouseImage from './GreenHouseImage';
import Language from '../../../language/language.json'; 
import Fullpage from '../../../hoc/Fullpage/Fullpage';

import * as homeActions from '../actions/homeActions';

//import Style classes
import './GreenHouse.css';

class GreenHouse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url : ''
        }
    }

    componentDidMount() {
        this.props.onLoadCases();
    }

    render() {
        //images should be 16:9 aspect ratio (best: 1410 X (1410x9/16))
        let images = this.props.cases && this.props.cases.map((obj, idx) => {
            // console.log(obj)
            return (
                <GreenHouseImage key={idx} obj={obj} universal={this.props.universal}></GreenHouseImage>
            )
        })

    return (
            <div className='GreenHouse'>
                <div className='CarouselWrapper'>
                    <Carousel
                        cellAlign="center"
                        slideWidth={1}
                        initialSlideHeight={800}
                        cellSpacing={50}
                        speed={1000}
                    autoplay={true}
                        autoplayInterval={2000}
                        dragging
                        swiping
                        wrapAround
                        transitionMode="scroll"
                        heightMode="max">
                        {images}
                    </Carousel>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        cases : state.home.cases,
        universal: state.universal
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadCases : () => {
            dispatch(homeActions.loadCases());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GreenHouse);


// WEBPACK FOOTER //
// ./src/pages/Home/GreenHouse/GreenHouse.js